import * as React from 'react';
import { useAsyncDebounce } from 'react-table';

// Custom Controls
import BaseInputControl from './BaseInputControl';

// Types
import { IMultiLineControlProps } from '@/@types/controls/controls';
import { HashMap } from './types';

function MultiLineControl(props: IMultiLineControlProps) {
  const { field, type, value, onChange, ...otherProps } = props;

  const [localValue, setLocalValue] = React.useState<string>(value ?? '');

  React.useEffect(() => {
    setLocalValue(value ?? '');
  }, [value]);

  const debouncedOnChange = useAsyncDebounce((val: string) => {
    if (onChange) onChange(val, field.source);
  }, 150);

  const handleChange = (newValue: string, source: string) => {
    let isValueParsedAndSubmit = false;
    try {
      const tmp: HashMap = JSON.parse(newValue as string);
      isValueParsedAndSubmit = '#submit' in tmp && tmp['#submit'];
    } catch (_) {
      // do nothing and proceed
    }

    if (!isValueParsedAndSubmit){
      setLocalValue(newValue);
    }
   
    debouncedOnChange(newValue);
  };

  return (
    <BaseInputControl
      type="text"
      field={field}
      {...otherProps}
      onChange={handleChange}
      value={localValue}
      multiline={true}
      rows={field.rows}
      // maxRows={field.maxRows}
    />
  );
}

export default MultiLineControl;
